import { Radio as RadioComponent, RadioProps } from '@chakra-ui/react';

const Radio: React.FC<RadioProps> = props => <RadioComponent {...props} />;

export default Radio;
